import React from 'react';
import { ApiUrlData, WebUrlData } from '@base-configs';
import { InitialValuePageProviderEntity } from '@base-entities';
import { PageProvider } from '@base-providers';
import { PageController } from '@base-components';

import { ActivityEntity } from '../../domain/entities';
import { makeActivityTransformer } from '../../domain/factories';

import PageIndex from '../pages';
import PageForm from '../pages/form';
import PageDetail from '../pages/detail';

export function ActivityFactory() {
  const transformer = makeActivityTransformer<ActivityEntity>();
  const InitialValue: InitialValuePageProviderEntity<ActivityEntity> = {
    transformer,
    moduleKey: 'activity-activities-page', // make sure this key unique each module
    webUrl: WebUrlData.activity_activities,
    apiUrl: ApiUrlData.activity_activities,
  };

  return (
    <PageProvider initialValue={InitialValue}>
      <PageController
        PageIndex={PageIndex}
        PageDetail={PageDetail}
        PageCreate={PageForm}
        PageUpdate={PageForm}
        PageDuplicate={PageForm}
      />
    </PageProvider>
  );
}
